module.exports = __webpack_public_path__ + "static/img/img_solution_case@2x.63b0992.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/解决方案/img_solution_case@2x.png
// module id = Diri
// module chunks = 0